import Button from 'components/control/button';
import styles from './style.module.scss';
import NotificationIcon from 'components/icon/notification-icon';
import HeartIcon from 'components/icon/heart-icon';
import Link from 'components/link';
import { listingPageModalIds } from 'constants/test-constants';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

type FavouritePromptProps = {
  listingId: number;
  isFavourited: boolean;
  onSeeAllSavedListingsClick?: (listingId: number) => void;
  onAddToFavouritesClick?: (listingId: number) => void;
};

export default function FavouritePrompt({ listingId, isFavourited, onSeeAllSavedListingsClick, onAddToFavouritesClick }: FavouritePromptProps) {
  const { t } = useTranslation(Namespaces.COMMON);

  const handleSeeAllSavedListingsClick = () => {
    onSeeAllSavedListingsClick?.(listingId);
  };

  const handleAddToFavouritesClick = () => {
    onAddToFavouritesClick?.(listingId);
  };

  return (
    <div className={styles.component} data-testid={listingPageModalIds.favouritePrompt}>
      {isFavourited ?
        <>
          <HeartIcon className={styles.icon} />
          <div className={styles['favourited-text']}>
            <p data-testid={listingPageModalIds.favouritePromptText}>{t(LOCALE_COMMON_PATHS.ADDRESS_FAVOURITE_PROMPT_YOU_WILL_BE_NOTIFIED, {
              defaultValue: 'You will be notified for this property.',
            })}
            <br />
            <Link href="/account/saved/favourites" onClick={handleSeeAllSavedListingsClick} testId={listingPageModalIds.favouritePromptSavedListingsLink} >
              {t(LOCALE_COMMON_PATHS.ADDRESS_FAVOURITE_PROMPT_SEE_ALL_SAVED_LISTINGS)}
            </Link>
            </p>
          </div>
        </>
        :
        <>
          <NotificationIcon className={styles.icon} />
          <p data-testid={listingPageModalIds.favouritePromptText}>{t(LOCALE_COMMON_PATHS.ADDRESS_FAVOURITE_PROMPT_GET_NOTIFIED, {
            defaultValue: 'Get notified of price or status changes by saving this listing',
          })}</p>
          <Button label={t(LOCALE_COMMON_PATHS.ADDRESS_FAVOURITE_PROMPT_GET_NOTIFIED_BUTTON, {
            defaultValue: 'Get Notified',
          })} type="submit" theme="tertiary" onClick={handleAddToFavouritesClick} testId={listingPageModalIds.favouritePromptAddButton} />
        </>
      }
    </div>
  );
}
